import { Stack, Typography } from '@mui/material';
import { MprcContainer, MprcLink, MprcRequestErrorDialog, MprcSpinnerIndicator, MprcTypography } from 'components';
import { MprcCardTypography } from 'components/MprcCardTypography';
import { TrainingPanelSeeAlsoResponse } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TrainingRegistrationDialog } from 'views/lms/student/Registration/TrainingRegistrationDialog';

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    trainingId: string;
}

/////////////////////////////////////////////////////////////////////////////////////

export const TrainingViewSeeAlsoBox: React.FC<IProps> = (props) => {

    const { trainingId } = props;

    const { t } = useTranslation("lms");
    const api = useCoreApi();

    const [trainings, setTrainings] = useState<TrainingPanelSeeAlsoResponse[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();
    const [dialog, setDialog] = useState<any>();

    const handleClick = (item: TrainingPanelSeeAlsoResponse) => {
        setDialog(<TrainingRegistrationDialog
            trainingId={item.trainingId}
            onClose={(reload) => setDialog(null)}
        />);
    };

    useEffect(() => {
        async function getData() {
            try {
                var result = await api.v1.enrollment.getTrainingPanelSeeAlso({
                    trainingId
                });
                setTrainings(result.data);
            } catch (e) {
                setViewError(e);
            } finally {
                setLoading(false);
            }
        }

        if (loading) getData();

    }, [loading]);

    return (
        <>
            {dialog}
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(undefined)} />
            {
                loading
                    ? (
                        <MprcContainer margin="dense">
                            <MprcSpinnerIndicator />
                        </MprcContainer>
                    )
                    : (
                        <>
                            {trainings.length > 0 &&
                                <div>
                                    <MprcContainer margin="dense">
                                        <Typography variant="h3">{t("Student.EnrollmentView.SeeAlsoBox.Title")}</Typography>
                                    </MprcContainer>
                                    <MprcContainer margin="dense">
                                        <Stack gap={2}>
                                            {
                                                trainings.map((item) => {
                                                    return (
                                                        <Stack key={item.trainingId}>
                                                            <MprcCardTypography
                                                                variant="caption"
                                                                noWrap
                                                                component="p"
                                                                color="muted"
                                                            >
                                                                {item.contentType}
                                                            </MprcCardTypography>
                                                            <MprcLink
                                                                onClick={() => handleClick(item)}
                                                            >
                                                                <MprcTypography variant="h6" noWrapRows={2}>
                                                                    {item.name}
                                                                </MprcTypography>
                                                            </MprcLink>
                                                        </Stack>
                                                    );
                                                })
                                            }
                                        </Stack>
                                    </MprcContainer>
                                </div>
                            }
                        </>
                    )
            }
        </>
    );
};
